import * as ActionTypes from '../../actions/allActions'

const accountProfile = (state = { canSubmit: true, form_errors: {}, showModal: false }, action) => {
	switch (action.type) {
		case ActionTypes.ACCOUNT_PROFILE_METACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.ACCOUNT_PROFILE_REQUEST:
			return { ...state, form_errors : {} }
		case ActionTypes.BACKEND_FORM_ERROR:
			return { ...state, form_errors: action.form_errors }
		default:
			return state
	}
}

export default accountProfile


// WEBPACK FOOTER //
// ./src/reducers/metadata/accountProfile.js